import MultModal from "@/pages/example/multModal/demo";
import AsyncGenerateTable from "@/pages/example/asyncGenerateTable/demo";
import React from "react";
import Demo from "../pages/example/demo/demo";
import Demo1 from "../pages/example/demo_1/demo";
import Demo2 from "../pages/example/demo_2/demo";
import CloneTable from "../pages/cloneTable/demo";

class ExampleTabs {
  constructor(addTab) {
    return this.init(addTab);
  }

  init(addTab) {
    const Frame = {
      demo1: <Demo addTab={addTab} />,
      demo2: <Demo1 />,
      demo3: <Demo2 />,
      demo4: <CloneTable></CloneTable>,
      demo5: <MultModal />,
      demo6: <AsyncGenerateTable />,
    };
    return Frame;
  }
}

export default ExampleTabs;



// WEBPACK FOOTER //
// ./src/AntD/tabs/exampleTabs.js